// File: frontend/src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { initializeBootstrap } from './utils/bootstrap';
import AppRoutes from './routes';
import ScrollToTop from './components/utility/ScrollToTop';
import SmoothScroll from './components/common/SmoothScroll'; // NEW
import ErrorBoundary from './components/utility/ErrorBoundary';
import ChatWidget from './components/chat/ChatWidget';
import CookieBanner from './components/auth/CookieBanner';

import './styles/main.css';

const App = () => {
  useEffect(() => {
    // Initialize anonymous user session on app mount
    initializeBootstrap();
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <LanguageProvider>
          <AuthProvider>
            <SmoothScroll />
            <ScrollToTop />
            <AppRoutes />
            <ChatWidget />
            <CookieBanner />
          </AuthProvider>
        </LanguageProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App;